<template>
  <div :style="$route.path.includes('create-order')? 'width: 33% !important; margin-left: 5px;': 'width: 100% !important; ' ">
    <b-form-group
      id="input-group-1"
      :label="$t(labelText)"
      label-for="input-1"
      width="auto"
    >
      <vue-dropzone
        id="customdropzone"
        ref="myVueDropzone"
        :options="dropzoneOptions"
        :include-styling="true"
        @vdropzone-files-added="fileAdded"
        @vdropzone-removed-file="removeFile"
      />
      <p
        v-show="showFileError == true"
        :class="{ 'hidden': showFileError == true}"
        style="color:#ff0000 ;"
      >{{ $t('ErrorUploadingPhoto') }}</p>
      <pre />
    </b-form-group>
  </div>
</template>
<script>
import AWS from 'aws-sdk';
import vue2Dropzone from 'vue2-dropzone'
import { AWSurl } from '../domainConfig';
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  components: {
    vueDropzone: vue2Dropzone,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['fileName', 'fileFormat', 'labelText', 'folder', 'maxFiles', 'fileDataType', 'occasion'],
  data() {
    return {
      showFileError: false,
      fileData: [],
      bucketName: AWSurl.bucketName,
      dropzoneOptions: {
        url: 'https://localhost.org/post',
        thumbnailWidth: 100,
        autoProcessQueue: false,
        thumbnailHeight: 100,
        multiple: true,
        dictDefaultMessage: `<span><svg width="56" height="56" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="3" width="40" height="40" rx="20" fill="#0F1626" fill-opacity="0.06"/>
<rect x="3" y="3" width="40" height="40" rx="20" stroke="#F9FAFB" stroke-width="6"/>
<g clip-path="url(#clip0_3_3204)">
<path d="M26.3333 26.3332L23 22.9999M23 22.9999L19.6666 26.3332M23 22.9999V30.4999M29.9916 28.3249C30.8044 27.8818 31.4465 27.1806 31.8165 26.3321C32.1866 25.4835 32.2635 24.5359 32.0351 23.6388C31.8068 22.7417 31.2862 21.9462 30.5555 21.3778C29.8248 20.8094 28.9257 20.5005 28 20.4999H26.95C26.6977 19.5243 26.2276 18.6185 25.5749 17.8507C24.9222 17.0829 24.104 16.4731 23.1817 16.0671C22.2594 15.661 21.2571 15.4694 20.2501 15.5065C19.243 15.5436 18.2575 15.8085 17.3676 16.2813C16.4777 16.7541 15.7066 17.4225 15.1122 18.2362C14.5177 19.05 14.1155 19.9879 13.9358 20.9794C13.756 21.9709 13.8034 22.9903 14.0743 23.961C14.3452 24.9316 14.8327 25.8281 15.5 26.5832" stroke="#475467" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_3_3204">
<rect width="20" height="20" fill="white" transform="translate(13 13)"/>
</clipPath>
</defs>
</svg>
<p style='margin-top: 10px; font-size: 14px; font-weight: 500; color: #667085'><span style="color: #FF274F; font-weight: 600">${this.$t('ClickToUpload')}</span>${this.$t('DragDrop')}<br>PDF, PNG, JPG or .doc</p></span>`,
        addRemoveLinks: true,
        error: false,
        maxFilesize: 50,
        headers: { 'My-Awesome-Header': 'header value' },
      },
    }
  },
  created() {
    AWS.config.update({
      accessKeyId: AWSurl.accessKeyId,
      secretAccessKey: AWSurl.secretAccessKey,
      region: AWSurl.region,
    });

    this.s3 = new AWS.S3();

    if (this.$route.path.includes('/profile')) {
      this.dropzoneOptions.maxFiles = 1;
    }
  },
  beforeDestroy() {
    this.showFileError = false;
  },
  methods: {
    onBeforeDelete(fileRecord) {
      // optionally, you can confirm and call the deleteFileRecord method
      this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
    },
    fileAdded(event) {
      const files = event;
      const self = this; // Capture 'this' to use inside the FileReader callback

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        // Create a placeholder object, even if file.upload is not immediately available
        const fileInfo = {
          fileName: file.name.split('.')[0],
          filetype: file.type.split('/')[1],
          index: file.upload && file.upload.uuid ? file.upload.uuid : null, // Temporarily set to null if upload.uuid is not available
        };

        const fileContent = new FileReader();

        fileContent.onload = function (events) {
          fileInfo.fileContent = events.target.result;

          // Push file info to the array, even without UUID, to display progress
          self.fileData.push(fileInfo);

          if (self.fileData.length === files.length) {
            if (self.$route.path.includes('/profile')) {
              self.isDropzoneDisabled = true;
              self.$refs.myVueDropzone.disable();
            }
          }
        };

        // Read the file content (this happens immediately)
        fileContent.readAsDataURL(file);

        // Check later when `upload` becomes available (for drag-and-drop, it may populate later)
        if (!file.upload || !file.upload.uuid) {
          // Add a watcher or hook to wait for the upload UUID (based on how your file-uploading library works)
          // Polling approach or a reactive update could be used if the library updates upload info later
          this.$nextTick(() => {
            if (file.upload && file.upload.uuid) {
              // Update the file record with the correct UUID
              fileInfo.index = file.upload.uuid;
            }
          });
        }
      }
    },
    removeFile(uuid) {
      this.fileData.splice(uuid, 1);
      if (this.$route.path.includes('/profile')) {
        this.isDropzoneDisabled = false;
        this.$refs.myVueDropzone.enable();
      }
    },
    uploadFileToS3(fileData) {
      const buf = Buffer.from(fileData.fileContent.replace(/^data:(image\/\w+|application\/pdf|text\/plain|application\/msword|application\/vnd\.openxmlformats-officedocument\.wordprocessingml\.document|application\/vnd\.ms-excel|application\/vnd\.openxmlformats-officedocument\.spreadsheetml\.sheet|image\/svg\+xml);base64,/, ''), 'base64');

      return new Promise((resolve, reject) => {
        const isUsersRoute = this.$route.path.includes('users') || this.$route.path.includes('/finance-report');
        const fileUrls = [];
        const fileDataType = this.fileDataType;

        let selectedBucket = AWSurl.bucketName;
        if (this.occasion === 'Inventory') {
          selectedBucket = AWSurl.bucketNameInventoryManagement;
        }

        const params = {
          Bucket: selectedBucket,
          Key: `${this.folder}/${Date.now()}-${fileData.fileName}.${fileData.filetype}`,
          Body: buf,
          ContentType: `application/${fileData.filetype}`,
          ACL: isUsersRoute ? null : 'public-read',
        };

        this.s3.putObject(params, (error) => {
          if (error) {
            console.log('File upload failed to S3:', error);
            reject(error);
          } else {
            if (this.fileFormat == 'firstFormat') {
              fileUrls.push(params.Key);
              const existingIndex = this.fileName.findIndex((item) => { return item.fileDataType === fileDataType });

              if (existingIndex === -1) {
                this.fileName.push({
                  fileUrl: fileUrls,
                  fileDataType,
                });
              } else {
                this.fileName[existingIndex].fileUrl.push(...fileUrls);
              }
            } else if (this.fileFormat == 'secondFormat') {
              this.fileName.push({ fileName: params.Key, fileDataType });
            } else if (this.fileFormat == 'thirdFormat') {
              this.fileName.push({ key: [params.Key], documentType: fileDataType, expiryDate: '2023-12-12' });
            } else if (this.fileFormat == 'fourthFormat') {
              this.fileName.push(params.Key);
            } else {
              this.fileName.push(params.Key);
            }
            console.log('File uploaded successfully to S3');
            resolve();
          }
        });
      });
    },
    async uploadFile() {
      // eslint-disable-next-line no-restricted-syntax
      for (const fileData of this.fileData) {
        // eslint-disable-next-line no-await-in-loop
        await this.uploadFileToS3(fileData);
      }
    },
  },
}
</script>
<style>
 @import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");
  #customdropzone .dz-success-mark, .dz-error-mark, .dz-remove {
    margin-left: 0px !important;
    font-size: 0.5rem !important ;
    width: 100% !important;
    bottom: 1px !important;
    border-radius: 8px !important;
  }
 .vue-dropzone {
   border: 1px solid #e5e5e5 !important;
   font-family: Arial, sans-serif;
   letter-spacing: .2px;
   color: #777;
   transition: .2s linear;
   border-radius: 8px;
 }
 .dropzone {
   min-height: 126px;
   padding: 0;
 }
 .dropzone .dz-message {
   margin: 20px 0;
 }
  /* .dz-error-mark{
    display: none !important;
  } */
  .dz-progress{
    display: none !important;
  }
  .dz-size{
    display: none !important;
  }
  .dz-filename{
    width: 100%;
  }
</style>
